import Download from '../../src/legacy/Download.tsx';
export default Download;
